const photoLocations = [
  { name: "CVS Pharmacy", link: "https://www.cvs.com/store-locator/", note: "Walk-in passport photos at most Tennessee locations" },
  { name: "Walgreens", link: "https://www.walgreens.com/storelocator", note: "Appointment recommended, walk-ins accepted statewide" },
  { name: "UPS Store", link: "https://www.theupsstore.com/tools/find-a-store", note: "Also handles overnight shipping of documents" },
  { name: "FedEx Office", link: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Photos + shipping in one stop" },
  { name: "Walmart", link: "https://www.walmart.com/store-finder", note: "Photo center at select Tennessee locations" },
  { name: "Costco", link: "https://www.costco.com/warehouse-locations", note: "Affordable passport photos at Tennessee warehouse locations" },
];

const airports = [
  { code: "BNA", name: "Nashville International Airport", address: "1 Terminal Dr, Nashville, TN 37214", link: "https://www.flynashville.com/" },
  { code: "MEM", name: "Memphis International Airport", address: "2491 Winchester Rd, Memphis, TN 38116", link: "https://www.memphisairport.org/" },
  { code: "TYS", name: "McGhee Tyson Airport (Knoxville)", address: "2055 Alcoa Hwy, Alcoa, TN 37701", link: "https://www.tys.org/" },
  { code: "CHA", name: "Chattanooga Airport", address: "1001 Airport Rd, Chattanooga, TN 37421", link: "https://www.chattairport.com/" },
  { code: "TRI", name: "Tri-Cities Airport (Johnson City)", address: "2525 Hwy 75, Blountville, TN 37617", link: "https://www.triflight.com/" },
  { code: "MQY", name: "Smyrna/Rutherford Co. Airport", address: "300 Fitzhugh Blvd, Smyrna, TN 37167", link: "https://www.smyrnaairport.com/" },
];

const shippingOptions = [
  { name: "FedEx", locator: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Priority Overnight for document submission" },
  { name: "UPS", locator: "https://www.theupsstore.com/tools/find-a-store", note: "Next Day Air Early AM available" },
  { name: "USPS", locator: "https://tools.usps.com/find-location.htm", note: "Priority Mail Express with tracking" },
];

export default function TennesseeStateResources() {
  return (
    <section id="resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">State Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Tennessee Passport Resources
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Everything Tennessee travelers need — photo locations, shipping options, airports, vital records, and the regional passport agency serving the Volunteer State.
          </p>
        </div>

        {/* Passport Photo Locations */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Passport Photo Locations</h3>
              <p className="text-gray-400 text-xs">Find a location near you — most offer walk-in service</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photoLocations.map((loc, i) => (
              <a key={i} href={loc.link} target="_blank" rel="noopener noreferrer nofollow" className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{loc.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{loc.note}</p>
              </a>
            ))}
          </div>
          <div className="mt-4 bg-[#FEF9E7] border border-[#F6C344]/20 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#F6C344] text-lg"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-[#1A365D]">Photo requirements:</strong> 2×2 inches, white or off-white background, taken within the last 6 months. A bad photo is the #1 reason passport applications get delayed — always verify specs before submitting.
            </p>
          </div>
        </div>

        {/* Tennessee Airports */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Major Tennessee Airports</h3>
              <p className="text-gray-400 text-xs">International departure points — verify passport validity before booking</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {airports.map((ap, i) => (
              <a key={i} href={ap.link} target="_blank" rel="noopener noreferrer nofollow" className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-[#1A365D] text-white text-xs font-bold px-2 py-0.5 rounded">{ap.code}</span>
                    <h4 className="font-semibold text-[#1A365D] text-sm">{ap.name}</h4>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ap.address}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Atlanta Passport Agency */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-[#F6C344]/30">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Atlanta Passport Agency</h3>
                <span className="inline-block bg-[#F6C344]/20 text-[#1A365D] text-xs font-semibold px-2 py-0.5 rounded-full">Closest to Tennessee</span>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">230 Peachtree Street NW, Suite 1000<br/>Atlanta, GA 30303</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                The Atlanta Passport Agency is the closest regional passport agency for Tennessee residents — serving all 95 counties. Chattanooga is approximately 2 hours away, Knoxville about 3 hours, and Nashville about 4 hours. For all Tennessee travelers, using a courier service is the fastest and most convenient option.
              </p>
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Chicago Passport Agency</h3>
                <p className="text-gray-400 text-xs">Alternative for West Tennessee</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">230 S Dearborn St, Suite 380<br/>Chicago, IL 60604</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                For Memphis and West Tennessee travelers, the Chicago Passport Agency is an alternative — approximately 530 miles north via I-55. Fast Passport Center's couriers serve the Atlanta agency as the primary Tennessee processing route.
              </p>
            </div>
          </div>
        </div>

        {/* Tennessee Vital Records */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Tennessee Vital Records</h3>
              <p className="text-gray-400 text-xs">Birth certificates for passport applications</p>
            </div>
          </div>
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              First-time passport applicants need a certified birth certificate. Tennessee birth records can be ordered through the Tennessee Department of Health Office of Vital Records or through the county health department where the birth occurred.
            </p>
            <a href="https://www.tn.gov/health/health-program-areas/records/birth-records.html" target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap">
              Order Tennessee Birth Certificate <i className="ri-external-link-line"></i>
            </a>
            <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Standard processing: 4–6 weeks. Expedited available through some counties.</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">$15 per certified copy (Tennessee Department of Health)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Shipping Options */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Shipping & Document Delivery</h3>
              <p className="text-gray-400 text-xs">Overnight options for getting documents to the processing center fast</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {shippingOptions.map((ship, i) => (
              <a key={i} href={ship.locator} target="_blank" rel="noopener noreferrer nofollow" className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{ship.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ship.note}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom tip */}
        <div className="bg-[#0F2240] rounded-lg p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-4">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <h4 className="font-bold text-white text-base mb-2">Pro Tip for Tennessee Travelers</h4>
          <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
            Tennessee does not have a regional passport agency within state borders — the closest is the Atlanta Passport Agency at 230 Peachtree Street NW. Music industry touring from Nashville, healthcare conferences at Vanderbilt, and summer Caribbean travel are the peak demand drivers for Tennessee passport services. Whether you are in East, Middle, or West Tennessee and have an urgent need, our courier service eliminates the 2 to 6 hour drive to Atlanta entirely.
          </p>
        </div>
      </div>
    </section>
  );
}